(function () {
  var VISIBLE_DOTS = 5;
  var DOT_SIZE = 8;
  var GAP = 8;

  var mainGallery = document.querySelector(".product-gallery__main");
  if (!mainGallery) return;

  var slides = mainGallery.querySelectorAll(".product-gallery__image");
  var total = slides.length;
  if (total <= 1) return;

  // Build structure: viewport (clipped window) > track (all dots)
  var dotsWrap = document.createElement("div");
  dotsWrap.className = "main-image-dots";

  var viewport = document.createElement("div");
  viewport.className = "main-image-dots__viewport";

  var track = document.createElement("div");
  track.className = "main-image-dots__track";

  // Set viewport width to fit exactly VISIBLE_DOTS
  var viewportWidth = VISIBLE_DOTS * DOT_SIZE + (VISIBLE_DOTS - 1) * GAP;
  // Add a bit extra so scaled active/edge dots aren't clipped
  viewport.style.width = viewportWidth + 6 + "px";

  for (var i = 0; i < total; i++) {
    var dot = document.createElement("button");
    dot.type = "button";
    dot.dataset.index = i;
    dot.setAttribute("aria-label", "Go to image " + (i + 1));
    track.appendChild(dot);
  }

  viewport.appendChild(track);
  dotsWrap.appendChild(viewport);
  mainGallery.parentNode.insertBefore(dotsWrap, mainGallery.nextSibling);

  var dots = track.querySelectorAll("button");
  var stepWidth = DOT_SIZE + GAP;
  var currentIndex = 0;

  function update(activeIndex) {
    currentIndex = activeIndex;

    dots.forEach(function (d, i) {
      d.classList.remove("is-active", "is-edge");
      if (i === activeIndex) {
        d.classList.add("is-active");
      }
    });

    // If total fits in window, no shifting needed
    if (total <= VISIBLE_DOTS) {
      track.style.transform = "translateX(0)";
      return;
    }

    // Slide the track so the active dot stays roughly centered
    var half = Math.floor(VISIBLE_DOTS / 2);
    var startIndex = Math.max(
      0,
      Math.min(activeIndex - half, total - VISIBLE_DOTS)
    );
    track.style.transform = "translateX(-" + startIndex * stepWidth + "px)";

    // Mark edge dots (smallest ones at the ends of the visible window
    // when there are more dots beyond)
    var endIndex = startIndex + VISIBLE_DOTS - 1;
    if (startIndex > 0) {
      dots[startIndex].classList.add("is-edge");
    }
    if (endIndex < total - 1) {
      dots[endIndex].classList.add("is-edge");
    }
  }

  // Click a dot to jump to that image
  track.addEventListener("click", function (e) {
    var btn = e.target.closest("button");
    if (!btn) return;
    var idx = parseInt(btn.dataset.index, 10);
    var thumbs = document.querySelectorAll(".product-gallery__thumbnail");
    if (thumbs[idx]) thumbs[idx].click();
    update(idx);
  });

  // Detect which slide is currently visible.
  // Uses IntersectionObserver — works whether the gallery library swipes,
  // fades, scrolls, or repositions slides, since we just watch visibility.
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
            var idx = Array.prototype.indexOf.call(slides, entry.target);
            if (idx !== -1 && idx !== currentIndex) {
              update(idx);
            }
          }
        });
      },
      {
        root: mainGallery,
        threshold: [0.5, 0.75, 1.0],
      }
    );

    slides.forEach(function (slide) {
      io.observe(slide);
    });
  }

  // Fallback / extra signal: also watch thumbnail active state
  var thumbs = document.querySelectorAll(".product-gallery__thumbnail");
  if (thumbs.length) {
    var mo = new MutationObserver(function () {
      thumbs.forEach(function (thumb, i) {
        if (
          thumb.classList.contains("is-selected") ||
          thumb.classList.contains("is-active") ||
          thumb.classList.contains("active") ||
          thumb.getAttribute("aria-current") === "true"
        ) {
          if (i !== currentIndex) update(i);
        }
      });
    });
    thumbs.forEach(function (thumb) {
      mo.observe(thumb, {
        attributes: true,
        attributeFilter: ["class", "aria-current"],
      });
    });
  }

  update(0);
})();
